import { BioSample, BioSampleContainer } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';

type HasDifferentContainerInfoFieldsOut = { kitChanges: boolean; containerChanges: boolean };

const evalContainerInfoFieldsDiff = (
  sample: BioSample,
  container: Maybe<BioSampleContainer>,
): HasDifferentContainerInfoFieldsOut => ({
  kitChanges:
    sample.kitDescription !== container?.kitDescription ||
    sample.kitType !== container?.kitType ||
    sample.kitExpiryDate !== container?.kitExpirationDateStr,
  containerChanges:
    sample.containerDescription !== container?.containerDescription ||
    sample.containerType !== container?.containerType,
});

const hasDifferentContainerInfoFields = (sample: BioSample, container: Maybe<BioSampleContainer>): boolean => {
  const result = evalContainerInfoFieldsDiff(sample, container);
  return result.containerChanges || result.kitChanges;
};

export const BioSampleContainerUtil = {
  evalContainerInfoFieldsDiff,
  hasDifferentContainerInfoFields,
};
